import * as React from 'react'
import * as styles from './Facet.module.scss'
import * as cn from 'classnames'

// TODO(AVWebStorefront-1435): This is a temporary hack we need to do because
// Merch has been using facetText for different reasons.
const AMAZON_CHANNELS = 'Amazon Channels'
const PRIME_CHANNELS = 'Prime Video Channels'
const NEW_LOGO_PATH = 'https://m.media-amazon.com/images/G/01/digital/video/global/prime-logo-large-v4._CB509553088_.png'
const OLD_LOGO_RE = /.*(prime-logo-large-v2._V1_.png)/ig


interface FacetProps {
  facetType?: string
  facetText?: string
  facetAlternateText?: string
  facetImage?: string
  className?: string
}
const getProcessedFacetText = (text: string) => (
  text !== AMAZON_CHANNELS &&
    text !== PRIME_CHANNELS ?
    <span className={styles.facetText}>{text}</span> : null
)

const PrimeFacet = (props: FacetProps) => (
  <div className={cn(styles.facet, styles.primeFacet, props.className)}>
    <span className={styles.FacetImage}>
      <img
        src={NEW_LOGO_PATH}
        alt={props.facetAlternateText}
      />
    </span>
  </div>
)

const DefaultFacet = (props: FacetProps) => {
  if (!props.facetText && !props.facetImage && !props.facetAlternateText) {
    return null
  }
  return (
    <div className={cn(styles.facet, props.className)}>
      {getProcessedFacetText(props.facetText)}
      <span className={styles.FacetImage}>
        {
          props.facetImage
            ? (<img
              src={props.facetImage.replace(OLD_LOGO_RE, NEW_LOGO_PATH)}
              alt={props.facetAlternateText}
            />)
            : getProcessedFacetText(props.facetAlternateText)
        }
      </span>
    </div>
  )
}

const Facet = (props: FacetProps) => {
  if (!props || props.facetType === 'NONE') {
    return null
  }
  if (props.facetType === 'PRIME') {
    return (<PrimeFacet {...props} />)
  }
  return (<DefaultFacet {...props} />)
}

export default Facet
